export const getRootUrl = () => {
  return process.env.REACT_APP_API_BASEURL
  // switch (process.env.REACT_APP_ENV) {
  //   case 'local':
  //     return process.env.REACT_APP_LOCAL_API_BASEURL;
  //   case 'developement':
  //     return process.env.REACT_APP_DEV_API_BASEURL;
  //   case 'production':
  //     return process.env.REACT_APP_PROD_API_BASEURL;
  // }
};

export const rootUrl = getRootUrl();
